<template>
  <v-container>
    <v-row align="center">
      <v-col cols="6">
        <evaluado-info-card-component :expediente="expediente[0]" />
      </v-col>
      <v-col cols="12">
        <v-card
          class="card"
          color="primary"
        >
          <v-card-title class="font-weight-bold justify-center">
            Evaluación médica
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-form v-model="medicoForm">
                <v-row align="center">
                  <v-col cols="12">
                    <div class="text-h6">
                      Portación de arma
                    </div>
                  </v-col>
                  <v-col cols="12">
                    <v-switch
                      v-model="medico.portacionArma"
                      inset
                      color="secondary"
                      label="Portación de arma"
                    />
                    <v-select
                      v-model="medico.fk_idTipoArma"
                      label="Tipo de arma"
                      background-color="primary"
                      color="secondary"
                      rounded
                      filled
                      :items="tipoArma"
                      item-value="id"
                      item-text="title"
                      :disabled="!medico.portacionArma"
                    />
                    <v-divider />
                  </v-col>
                </v-row>
                <v-row align="center">
                  <v-col cols="12">
                    <div class="text-h6">
                      Vista
                    </div>
                  </v-col>
                  <v-col cols="6">
                    <v-select
                      v-model="medico.fk_idCatAgudezaVisual"
                      label="Agudeza visual"
                      background-color="primary"
                      color="secondary"
                      rounded
                      filled
                      dense
                      :items="agudezaVisual"
                      item-value="id"
                      item-text="title"
                      validate-on-blur
                      :rules="required"
                    />
                  </v-col>
                  <v-col cols="6">
                    <v-select
                      v-model="medico.fk_idCatPterigion"
                      label="Pterigión"
                      background-color="primary"
                      color="secondary"
                      rounded
                      filled
                      dense
                      :items="pterigion"
                      item-value="id"
                      item-text="title"
                      validate-on-blur
                      :rules="required"
                    />
                  </v-col>
                  <v-col cols="12">
                    <v-divider />
                  </v-col>
                </v-row>
                <v-row align="center">
                  <v-col cols="12">
                    <div class="text-h6">
                      Síndrome metabólico
                    </div>
                  </v-col>
                  <v-col cols="12">
                    <v-select
                      v-model="medico.fk_idCatEstadoNutricional"
                      label="Estado nutricional"
                      background-color="primary"
                      color="secondary"
                      rounded
                      filled
                      dense
                      :items="estadoNutricional"
                      item-value="id"
                      item-text="title"
                      :rules="required"
                    />
                    <v-checkbox
                      v-model="medico.diabetesMellitusTipo2"
                      color="secondary"
                      label="Diabetes mellitus tipo 2"
                    />
                    <v-checkbox
                      v-model="medico.hipertensionArterial"
                      color="secondary"
                      label="Hipertensión arterial"
                    />
                    <v-checkbox
                      v-model="medico.dislipidemias"
                      color="secondary"
                      label="Dislipidemias"
                    />
                  </v-col>
                  <v-col cols="12">
                    <v-divider />
                  </v-col>
                </v-row>
                <v-row align="center">
                  <v-col cols="12">
                    <div class="text-h6">
                      Enfermedades
                    </div>
                  </v-col>
                  <v-col cols="12">
                    <v-select
                      v-model="medico.fk_idCatTipoTiroides"
                      label="Tipo de tiroides"
                      background-color="primary"
                      color="secondary"
                      rounded
                      filled
                      dense
                      :items="tipoTiroides"
                      item-value="id"
                      item-text="title"
                      :rules="required"
                    />
                    <v-checkbox
                      v-model="medico.enfermedadesCardiovasculares"
                      label="Cardiovasculares"
                      color="secondary"
                    />
                    <v-checkbox
                      v-model="medico.enfermerdadesRespiratorias"
                      label="Respiratorias"
                      color="secondary"
                    />
                    <v-checkbox
                      v-model="medico.enfermedadesMuscoesYOsteoten"
                      label="Musculoesqueléticas y osteontendinosas"
                      color="secondary"
                    />
                    <v-checkbox
                      v-model="medico.enfermedadesSistemaNervioso"
                      label="Del sistema nervioso"
                      color="secondary"
                    />
                    <v-checkbox
                      v-model="medico.enfermedadesTractoUrinario"
                      label="Del tractu urinario"
                      color="secondary"
                    />
                  </v-col>
                  <v-col cols="12">
                    <v-divider />
                  </v-col>
                </v-row>
                <v-row class="tatuaje-row">
                  <v-col cols="4">
                    <div class="text-h6">
                      Observaciones físicas
                    </div>
                    <v-checkbox
                      v-model="medico.fracturas"
                      label="Fracturas"
                      color="secondary"
                    />
                    <v-checkbox
                      v-model="medico.amputaciones"
                      label="Amputaciones"
                      color="secondary"
                    />
                    <v-checkbox
                      v-model="medico.pielYAnexos"
                      label="Enfermedades dermatológicas"
                      color="secondary"
                    />
                    <v-checkbox
                      v-model="medico.tatuajes"
                      label="Tatuajes"
                      color="secondary"
                    />
                    <v-list
                      color="primary"
                      dense
                      two-line
                    >
                      <v-subheader class="secondary--text font-weight-bold">
                        LISTA DE TATUAJES
                      </v-subheader>
                      <v-list-item
                        v-for="(tatuaje, index) in listaTatuajes"
                        :key="index"
                      >
                        <v-list-item-content>
                          <v-list-item-title>
                            <v-text-field
                              v-model="tatuaje.descripcion"
                              hide-details
                              label="Descripción tatuaje"
                              solo
                            />
                          </v-list-item-title>
                          <v-list-item-subtitle>{{ tatuaje.zona }}</v-list-item-subtitle>
                        </v-list-item-content>
                        <v-list-item-action>
                          <v-btn
                            icon
                            @click="quitaTatuaje(index)"
                          >
                            <v-icon color="error">
                              mdi-minus
                            </v-icon>
                          </v-btn>
                        </v-list-item-action>
                      </v-list-item>
                    </v-list>
                  </v-col>
                  <v-col
                    cols="8"
                    align="center"
                  >
                    <div class="human-body mt-16">
                      <svg
                        data-position="head"
                        class="head"
                        xmlns="http://www.w3.org/2000/svg"
                        width="56.594"
                        height="95.031"
                        viewBox="0 0 56.594 95.031"
                        @click="agregaTatuaje(1)"
                        @keydown="agregaTatuaje(1)"
                      >
                        <path
                          d="M15.92 68.5l8.8 12.546 3.97 13.984-9.254-7.38-4.622-15.848zm27.1 0l-8.8 12.546-3.976 13.988 9.254-7.38 4.622-15.848zm6.11-27.775l.108-11.775-21.16-14.742L8.123 26.133 8.09 40.19l-3.24.215 1.462 9.732 5.208 1.81 2.36 11.63 9.72 11.018 10.856-.324 9.56-10.37 1.918-11.952 5.207-1.81 1.342-9.517zm-43.085-1.84l-.257-13.82L28.226 11.9l23.618 15.755-.216 10.37 4.976-17.085L42.556 2.376 25.49 0 10.803 3.673.002 24.415z"
                        />
                      </svg>
                      <svg
                        data-position="shoulder"
                        class="shoulder"
                        xmlns="http://www.w3.org/2000/svg"
                        width="109.532"
                        height="46.594"
                        viewBox="0 0 109.532 46.594"
                        @click="agregaTatuaje(2)"
                        @keydown="agregaTatuaje(2)"
                      >
                        <path
                          d="M38.244-.004l1.98 9.232-11.653 2.857-7.474-2.637zm33.032 0l-1.98 9.232 11.653 2.857 7.474-2.637zm21.238 10.54l4.044-2.187 12.656 14 .07 5.33S92.76 10.66 92.515 10.535zm-1.285.58c-.008.28 17.762 18.922 17.762 18.922l.537 16.557-6.157-10.55L91.5 30.988 83.148 15.6zm-74.224-.58L12.962 8.35l-12.656 14-.062 5.325s16.52-17.015 16.764-17.14zm1.285.58C18.3 11.396.528 30.038.528 30.038L-.01 46.595l6.157-10.55 11.87-5.056L26.374 15.6z"
                        />
                      </svg>
                      <svg
                        data-position="arm"
                        class="arm"
                        xmlns="http://www.w3.org/2000/svg"
                        width="156.344"
                        height="119.25"
                        viewBox="0 0 156.344 119.25"
                        @click="agregaTatuaje(3)"
                        @keydown="agregaTatuaje(3)"
                      >
                        <path
                          d="M21.12 56.5a1.678 1.678 0 0 1-.427.33l.935 8.224 12.977-13.89 1.2-8.958A168.2 168.2 0 0 0 21.12 56.5zm1.387 12.522l-18.07 48.91 5.757 1.333 19.125-39.44 3.518-22.047zm-5.278-18.96l2.638 18.74-17.2 46.023L.01 113.05l6.644-35.518zm118.015 6.44a1.678 1.678 0 0 0 .426.33l-.934 8.222-12.977-13.89-1.2-8.958A168.2 168.2 0 0 1 135.24 56.5zm-1.39 12.52l18.073 48.91-5.758 1.333-19.132-39.44-3.52-22.05zm5.28-18.96l-2.64 18.74 17.2 46.023 2.658-1.775-6.643-35.518zm-103.1-12.323a1.78 1.78 0 0 1 .407-.24l3.666-27.345L33.07.015l-7.258 10.58-6.16 37.04.566 4.973a151.447 151.447 0 0 1 15.808-14.87zm84.3 0a1.824 1.824 0 0 0-.407-.24l-3.666-27.345L123.3.015l7.258 10.58 6.16 37.04-.566 4.973a151.447 151.447 0 0 0-15.822-14.87zM22.288 8.832l-3.3 35.276-2.2-26.238zm111.79 0l3.3 35.276 2.2-26.238z"
                        />
                      </svg>
                      <svg
                        data-position="cheast"
                        class="cheast"
                        xmlns="http://www.w3.org/2000/svg"
                        width="86.594"
                        height="45.063"
                        viewBox="0 0 86.594 45.063"
                        @click="agregaTatuaje(4)"
                        @keydown="agregaTatuaje(4)"
                      >
                        <path
                          d="M19.32 0l-9.225 16.488-10.1 5.056 6.15 4.836 4.832 14.07 11.2 4.616 17.85-8.828-4.452-34.7zm47.934 0l9.225 16.488 10.1 5.056-6.15 4.836-4.833 14.07-11.2 4.616-17.844-8.828 4.45-34.7z"
                        />
                      </svg>
                      <svg
                        data-position="stomach"
                        class="stomach"
                        xmlns="http://www.w3.org/2000/svg"
                        width="75.25"
                        height="107.594"
                        viewBox="0 0 75.25 107.594"
                        @click="agregaTatuaje(5)"
                        @keydown="agregaTatuaje(5)"
                      >
                        <path
                          d="M19.25 7.49l16.6-7.5-.5 12.16-14.943 7.662zm-10.322 8.9l6.9 3.848-.8-9.116zm5.617-8.732L1.32 2.15 6.3 15.6zm-8.17 9.267l9.015 5.514 1.54 11.028-8.795-5.735zm15.53 5.89l.332 8.662 12.286-2.665.664-11.826zm14.61 84.783L33.28 76.062l-.08-20.53-11.654-5.736-1.32 37.5zM22.735 35.64L22.57 46.3l11.787 3.166.166-16.657zm-14.16-5.255L16.49 35.9l1.1 11.25-8.8-7.06zm8.79 22.74l-9.673-7.28-.84 9.78L-.006 68.29l10.564 14.594 5.5.883 1.98-20.735zM56 7.488l-16.6-7.5.5 12.16 14.942 7.66zm10.32 8.9l-6.9 3.847.8-9.116zm-5.617-8.733L73.93 2.148l-4.98 13.447zm8.17 9.267l-9.015 5.514-1.54 11.03 8.8-5.736zm-15.53 5.89l-.332 8.662-12.285-2.665-.664-11.827zm-14.61 84.783l3.234-31.536.082-20.532 11.65-5.735 1.32 37.5zm13.78-71.957l.166 10.66-11.786 3.168-.166-16.657zm14.16-5.256l-7.915 5.514-1.1 11.25 8.794-7.06zm-8.79 22.743l9.673-7.28.84 9.78 6.862 12.66-10.564 14.597-5.5.883-1.975-20.74z"
                        />
                      </svg>
                      <svg
                        data-position="legs"
                        class="legs"
                        xmlns="http://www.w3.org/2000/svg"
                        width="93.626"
                        height="286.625"
                        viewBox="0 0 93.626 286.625"
                        @click="agregaTatuaje(6)"
                        @keydown="agregaTatuaje(6)"
                      >
                        <path
                          d="M17.143 138.643l-.664 5.99 4.647 5.77 1.55 9.1 3.1 1.33 2.655-13.755 1.77-4.88-1.55-3.107zm20.582.444l-3.32 9.318-7.082 13.755 1.77 12.647 5.09-14.2 4.205-7.982zm-26.557-12.645l5.09 27.29-3.32-1.777-2.656 8.875zm22.795 42.374l-1.55 4.88-3.32 20.634-.442 27.51 4.65 26.847-.223-34.39 4.87-13.754.663-15.087zM23.34 181.24l1.106 41.267 8.853 33.28-9.628-4.55-16.045-57.8 5.533-36.384zm15.934 80.536l-.664 18.415-1.55 6.435h-4.647l-1.327-4.437-1.55-.222.332 4.437-5.864-1.778-1.55-.887-6.64-1.442-.22-5.214 6.418-10.87 4.426-5.548 10.844-4.437zM13.63 3.076v22.476l15.71 31.073 9.923 30.85L38.23 66.1zm25.49 30.248l.118-.148-.793-2.024L21.9 12.992l-1.242-.44L31.642 40.93zM32.865 44.09l6.812 17.6 2.274-21.596-1.344-3.43zM6.395 61.91l.827 25.34 12.816 35.257-3.928 10.136L3.5 88.133zM30.96 74.69l.345.826 6.47 15.48-4.177 38.342-6.594-3.526 5.715-35.7zm45.5 63.953l.663 5.99-4.647 5.77-1.55 9.1-3.1 1.33-2.655-13.755-1.77-4.88 1.55-3.107zm-20.582.444l3.32 9.318 7.08 13.755-1.77 12.647-5.09-14.2-4.2-7.987zm3.762 29.73l1.55 4.88 3.32 20.633.442 27.51-4.648 26.847.22-34.39-4.867-13.754-.67-15.087zm10.623 12.424l-1.107 41.267-8.852 33.28 9.627-4.55 16.046-57.8-5.533-36.384zM54.33 261.777l.663 18.415 1.546 6.435h4.648l1.328-4.437 1.55-.222-.333 4.437 5.863-1.778 1.55-.887 6.638-1.442.222-5.214-6.418-10.868-4.426-5.547-10.844-4.437zm25.643-258.7v22.476L64.26 56.625l-9.923 30.85L55.37 66.1zM54.48 33.326l-.118-.15.793-2.023L71.7 12.993l1.24-.44L61.96 40.93zm6.255 10.764l-6.812 17.6-2.274-21.595 1.344-3.43zm26.47 17.82l-.827 25.342-12.816 35.256 3.927 10.136 12.61-44.51zM62.64 74.693l-.346.825-6.47 15.48 4.178 38.342 6.594-3.527-5.715-35.7zm19.792 51.75l-5.09 27.29 3.32-1.776 2.655 8.875zM9.495-.007l.827 21.373-7.028 42.308-3.306-34.155zm2.068 27.323L26.24 59.707l3.307 26-6.2 36.58L9.91 85.046l-.827-38.342zM84.103-.01l-.826 21.375 7.03 42.308 3.306-34.155zm-2.066 27.325L67.36 59.707l-3.308 26 6.2 36.58 13.436-37.24.827-38.34z"
                        />
                      </svg>
                      <svg
                        data-position="hands"
                        class="hands"
                        xmlns="http://www.w3.org/2000/svg"
                        width="205"
                        height="38.938"
                        viewBox="0 0 205 38.938"
                        @click="agregaTatuaje(7)"
                        @keydown="agregaTatuaje(7)"
                      >
                        <path
                          d="M21.255-.002l2.88 6.9 8.412 1.335.664 12.458-4.427 17.8-2.878-.22 2.8-11.847-2.99-.084-4.676 12.6-3.544-.446 4.4-12.736-3.072-.584-5.978 13.543-4.428-.445 6.088-14.1-2.1-1.25-7.528 12.012-3.764-.445L12.4 12.9l-1.107-1.78L.665 15.57 0 13.124l8.635-7.786zm162.49 0l-2.88 6.9-8.412 1.335-.664 12.458 4.427 17.8 2.878-.22-2.8-11.847 2.99-.084 4.676 12.6 3.544-.446-4.4-12.736 3.072-.584 5.978 13.543 4.428-.445-6.088-14.1 2.1-1.25 7.528 12.012 3.764-.445L192.6 12.9l1.107-1.78 10.628 4.45.665-2.447-8.635-7.786z"
                        />
                      </svg>
                    </div>
                  </v-col>
                </v-row>
                <v-row align="center">
                  <v-col cols="12">
                    <v-divider />
                  </v-col>
                  <v-col cols="12">
                    <div class="text-h6">
                      Observaciones
                    </div>
                  </v-col>
                  <v-col cols="12">
                    <v-textarea
                      v-model="medico.observaciones"
                      label="Observaciones"
                      rounded
                      filled
                      dense
                      color="secondary"
                      background-color="primary"
                      no-resize
                      rows="12"
                    />
                  </v-col>
                  <v-col cols="6">
                    <v-select
                      v-model="medico.fk_idCatSemaforoResultado"
                      label="Semáforo de resultado"
                      background-color="primary"
                      color="secondary"
                      rounded
                      filled
                      dense
                      :items="semaforoResultado"
                      item-value="id"
                      item-text="nombre"
                      item-color="secondary"
                      :rules="required"
                    />
                  </v-col>
                </v-row>
              </v-form>
            </v-container>
          </v-card-text>
          <v-card-actions class="justify-center">
            <v-btn
              rounded
              elevation="8"
              color="secondary"
              :loading="loading"
              :disabled="!medicoForm || loading"
              @click="triggerSave()"
            >
              Guardar evaluación
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
    <v-overlay
      :value="overlay"
      :z-index="999"
      align="center"
      color="secondary"
      opacity="1"
    >
      <v-progress-circular
        indeterminate
        color="primary"
      />
      <div class="text-overline mt-4">
        Cargando información. Por favor, espere...
      </div>
    </v-overlay>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import EvaluadoInfoCardComponent from '../../components/EvaluadoInfoCardComponent.vue';
import { circularProgressProps } from '../../components/props/props';

export default {
  components: {
    EvaluadoInfoCardComponent,
  },

  props: {
    idDerivacion: {
      type: Number,
      required: true,
    },

    idProgramacion: {
      type: Number,
      required: true,
    },

    idExpediente: {
      type: Number,
      required: true,
    },
  },

  data() {
    return {
      circularProgressProps,

      loading: false,
      medicoForm: false,
      overlay: false,

      medico: {
        fk_idDerivacion: this.idDerivacion,
        fk_idProgramacion: this.idProgramacion,
        fk_idExpediente: this.idExpediente,
        portacionArma: false,
        fk_idTipoArma: null,
        tatuajes: false,
        descripcionTatuajes: '',
        fk_idCatEstadoNutricional: null,
        fk_idCatAgudezaVisual: null,
        fk_idCatPterigion: null,
        discromatopsia: false,
        diabetesMellitusTipo2: false,
        hipertensionArterial: false,
        dislipidemias: false,
        fk_idCatTipoTiroides: null,
        enfermedadesCardiovasculares: false,
        enfermerdadesRespiratorias: false,
        enfermedadesMuscoesYOsteoten: false,
        fracturas: false,
        amputaciones: false,
        enfermedadesSistemaNervioso: false,
        enfermedadesTractoUrinario: false,
        pielYAnexos: false,
        hiperuricemia: false,
        observaciones: '',
        fk_idCatSemaforoResultado: null,
      },

      listaTatuajes: [],

      agudeza: null,

      required: [(v) => !!v || 'Este campo es requerido.'],
    };
  },

  computed: {
    ...mapGetters('expediente', {
      expediente: 'getExpedientesPersonal',
    }),

    ...mapGetters('agudezaVisual', {
      agudezaVisual: 'getAgudezaVisual',
    }),

    ...mapGetters('pterigion', {
      pterigion: 'getPterigion',
    }),

    ...mapGetters('estadoNutricional', {
      estadoNutricional: 'getEstadoNutricional',
    }),

    ...mapGetters('tipoTiroides', {
      tipoTiroides: 'getTipoTiroides',
    }),

    ...mapGetters('tipoArma', {
      tipoArma: 'getTipoArmas',
    }),

    ...mapGetters('semaforoResultado', {
      semaforoResultado: 'getSemaforoResultado',
    }),
  },

  async mounted() {
    this.overlay = true;
    await this.fetchExpedienteById(this.idExpediente);
    await this.fetchAgudezaVisual();
    await this.fetchPterigion();
    await this.fetchEstadoNutricional();
    await this.fetchTipoTiroides();
    await this.fetchTiposArma();
    this.overlay = false;
  },

  methods: {
    ...mapActions('agudezaVisual', ['fetchAgudezaVisual']),
    ...mapActions('pterigion', ['fetchPterigion']),
    ...mapActions('estadoNutricional', ['fetchEstadoNutricional']),
    ...mapActions('tipoTiroides', ['fetchTipoTiroides']),
    ...mapActions('evaluacionesMedico', ['saveEvaluacionMedico']),
    ...mapActions('expediente', ['fetchExpedienteById']),
    ...mapActions('tipoArma', ['fetchTiposArma']),

    agregaTatuaje(idPosition) {
      switch (idPosition) {
        case 1:
          this.listaTatuajes.push({
            zona: 'Cabeza',
            descripcion: '',
          });
          break;
        case 2:
          this.listaTatuajes.push({
            zona: 'Hombros',
            descripcion: '',
          });
          break;
        case 3:
          this.listaTatuajes.push({
            zona: 'Brazos',
            descripcion: '',
          });
          break;
        case 4:
          this.listaTatuajes.push({
            zona: 'Pecho',
            descripcion: '',
          });
          break;
        case 5:
          this.listaTatuajes.push({
            zona: 'Abdomen',
            descripcion: '',
          });
          break;
        case 6:
          this.listaTatuajes.push({
            zona: 'Piernas',
            descripcion: '',
          });
          break;
        case 7:
          this.listaTatuajes.push({
            zona: 'Manos',
            descripcion: '',
          });
          break;
        default:
          break;
      }
    },

    quitaTatuaje(index) {
      this.listaTatuajes.splice(index, 1);
    },

    async triggerSave() {
      this.loading = true;

      this.medico.descripcionTatuajes = JSON.stringify(this.listaTatuajes);
      await this.saveEvaluacionMedico(this.medico);

      this.loading = false;
      this.$router.push('/evaluaciones_medicas/personal');
    },
  },
};
</script>

<style scoped>
.tatuaje-row {
  height: 720px;
}
.human-body {
  width: 207px;
  position: relative;
}
.human-body svg:hover {
  cursor: pointer;
}
.human-body svg:hover path {
  fill: #ff7d16;
}
.human-body svg {
  position: absolute;
  left: 50%;
  fill: #673ab7;
}
.human-body svg.head {
  margin-left: -28.5px;
  top: -6px;
}
.human-body svg.shoulder {
  margin-left: -53.5px;
  top: 69px;
}
.human-body svg.arm {
  margin-left: -78px;
  top: 112px;
}
.human-body svg.cheast {
  margin-left: -43.5px;
  top: 88px;
}
.human-body svg.stomach {
  margin-left: -37.5px;
  top: 130px;
}
.human-body svg.legs {
  margin-left: -46.5px;
  top: 205px;
  z-index: 9999;
}
.human-body svg.hands {
  margin-left: -102.5px;
  top: 224px;
}
#area {
  display: block;
  width: 100%;
  clear: both;
  padding: 10px;
  text-align: center;
  font-size: 25px;
  font-family: Courier New;
  color: #a5a5a5;
}

#area #data {
  color: black;
}
</style>
